import axios from 'axios';

/*
 * 飞书消息文档 https://open.feishu.cn/document/client-docs/bot-v3/add-custom-bot
 */
// 经过后端加密
const user_can_at = {
    'dxy': 'ou_2d8f1077916ea28df79e2efe38c86893',
};
const webhookConfig = {
    // monitor监控报错
    monitor: 'https://open.feishu.cn/open-apis/bot/v2/hook/c67a56a2-22ae-484d-9078-42a71e51b1ac',
};
/**
 * 飞书消息通知-采用默认格式-页面路径需要自行放在text中
 * @param {String| String[]} text string | string[]
 * @param {Error} err 错误上报，将处理成string类型和堆栈信息，传入err具体信息将同步上报arms查看。
 * @param {String} webhook 飞书群 不传默认发送到 正式 / 测试消息通知群，有at默认发送到前端内部群
 * @param {null|string|string[]} at @ 名字缩写
 */
const feishuRobotSend = ({ text, err, at = 'dxy' }) => {
    if (typeof window === 'undefined')
        return;
    if (window.navigator.userAgent?.includes?.('Googlebot'))
        return;
    try {
        // local不报错
        if (!window.location?.protocol.includes('https')) {
            err && console.error(err);
            return console.log('---------飞书消息--------\n', text);
        }
        const title = `【FE.Monitor】推送`;
        const data = {
            'msg_type': 'post',
            'content': {
                'post': {
                    'zh_cn': {
                        'title': `${title}`,
                        'content': [
                            [
                                {
                                    'tag': 'text',
                                    'text': `页面路径:  ${window.location.href}`,
                                },
                            ],
                            [
                                {
                                    'tag': 'text',
                                    'text': `时间戳:  ${new Date().valueOf()}`,
                                },
                            ],
                            [
                                {
                                    'tag': 'text',
                                    'text': `UA:  ${window.navigator.userAgent + '  ' + window.navigator.platform}`,
                                },
                            ],
                            [
                                {
                                    'tag': 'text',
                                    'text': `=================`,
                                },
                            ],
                            ...(typeof text === 'string'
                                ? [
                                    [
                                        {
                                            'tag': 'text',
                                            'text': text,
                                        },
                                    ],
                                ]
                                : text.map((t) => [{ 'tag': 'text', 'text': t }])),
                        ],
                    },
                },
            },
        };
        if (err) {
            data.content.post.zh_cn.content.push([
                {
                    'tag': 'text',
                    'text': `=================`,
                },
            ], [
                {
                    tag: 'text',
                    text: `【错误信息】：${err.message} - ${JSON.stringify(err)}`,
                },
            ], [
                {
                    'tag': 'text',
                    'text': `=================`,
                },
            ], [
                {
                    tag: 'text',
                    text: `【堆栈信息】：${err instanceof Error ? err?.stack?.toString?.() : '无'}`,
                },
            ]);
        }
        if (at) {
            const _at = Array.isArray(at) ? at : [at];
            data.content.post.zh_cn.content.push(..._at.map((name) => [
                {
                    tag: 'at',
                    user_id: user_can_at[name],
                },
            ]));
        }
        axios?.({
            url: webhookConfig.monitor,
            method: 'post',
            data,
        });
    }
    catch (e) {
        console.error(e);
    }
};

/**
 * 轮询方法
 * @param {()=>boolean} func 如果成功返回true轮询停止
 * @param {*} delay 轮询间隔
 * @param {*} timer 轮询次数
 * @param {*} payload 方法参数,可以传非数组、数组（多个入参）、或者对象
 * @returns
 */
function intervalPromise(func, delay = 1000, timer = 10) {
    return new Promise((resolve, reject) => {
        let counter = 0;
        const t = setInterval(() => {
            try {
                const result = func();
                if (result) {
                    clearInterval(t);
                    resolve(true);
                }
                if (counter >= timer) {
                    clearInterval(t);
                    reject('intervalPromise 超时');
                }
                counter++;
            }
            catch (e) {
                clearInterval(t);
                reject(e);
            }
        }, delay);
    }).catch((err) => {
        feishuRobotSend({ err, text: 'intervalPromise' });
    });
}
/**
 * 解析Error的堆栈信息返回line和col
 * @param error 错误
 *
 */
const getErrorPos = (error) => {
    if (error instanceof Error && error?.stack) {
        const stackLines = error.stack.split('\n');
        // 一般第二行包含了详细的错误文件、行号和列号信息
        if (stackLines.length > 1) {
            const match = stackLines[1].match(/:(\d+):(\d+)/);
            if (match) {
                const lineno = parseInt(match[1], 10);
                const colno = parseInt(match[2], 10);
                return {
                    lineno,
                    colno,
                };
            }
        }
    }
    return {};
};
const isBrowser = typeof window !== 'undefined';
/** 返回JSON.stringify字符串，如果报错返回'' */
const getJSONstring = (data) => {
    try {
        return JSON.stringify(data);
    }
    catch (error) {
        console.error(error);
        return '';
    }
};
/** 自动判断当前页面路径的环境，以部门共用的环境后缀为判断方式
 * -sit / -test / -local / -dev将被判断为日常环境
 * localhost访问的链接为本地环境
 * 其他默认为线上环境
 */
const getEnv = (url) => {
    const { origin } = window.location;
    const href = origin;
    if (href.includes('-sit.insta360') ||
        href.includes('-test.insta360') ||
        href.includes('-local.insta360') ||
        href.includes('-dev.insta360')) {
        return 'daily';
    }
    if (href.includes('http://localhost'))
        return 'local';
    return 'prod';
};

/**
 * 在sdk加载之前存储埋点方法和数据的队列实例
 */
class _TaskQueue {
    constructor() {
        if (typeof window === 'undefined')
            return;
    }
    /**
     * 轮询消费队列
     */
    intervalExcuting = false;
    intervalComsume = () => {
        if (this.intervalExcuting)
            return;
        this.intervalExcuting = true;
        intervalPromise(() => {
            this.consume();
            return this.isQueueEmpty();
        }, 500, 10).finally(() => {
            this.intervalExcuting = false;
        });
    };
    /**
     * 队列列表
     */
    queue = [];
    /**
     * 判断队列列表是否为空
     */
    isQueueEmpty = () => {
        if (!this.queue.length)
            return true;
        if (this.queue.every((item) => !item.sdkQueue || item.sdkQueue.length === 0))
            return true;
        return false;
    };
    /**
     * 向埋点存储队列里增加数据。
     * @param sdkName sdk名称
     * @param event 运行方法
     * @param {Array} eventPayload 方法payload，必须是数组
     * @param {Object} _this 函数的运行环境，默认this指向window。
     */
    push = (sdkName, event, eventPayload, _this) => {
        if (typeof window === 'undefined')
            return;
        if (!!eventPayload && !Array.isArray(eventPayload)) {
            return console.error('pushQueue 参数错误');
        }
        const item = this.queue.find((d) => d.name === sdkName);
        if (item) {
            item.sdkQueue.push({ func: event, payload: eventPayload, context: _this });
        }
        else {
            this.queue.push({
                name: sdkName,
                sdkQueue: [{ func: event, payload: eventPayload, context: _this }],
            });
        }
    };
    /**
     * 消费埋点存储队列中的数据
     */
    consume = () => {
        this.queue.forEach((item) => {
            try {
                // 当前只处理这么多任务，避免因为意外导致无限push死循环
                const length = item.sdkQueue.length;
                let i = 0;
                while (i < length) {
                    const event = item.sdkQueue.shift();
                    event?.func.call(event.context, ...(event.payload ?? []));
                    i++;
                }
            }
            catch (err) {
                feishuRobotSend({ err: err, text: [`[${item.name}] consume error`] });
            }
        });
    };
    /**
     * 根据类别消费
     * @param {} type 埋点平台类型。
     */
    consumeByType = (type) => {
        try {
            const item = this.queue.find((d) => d.name === type);
            if (item) {
                // 当前只处理这么多任务，避免因为意外导致无限push死循环
                const length = item.sdkQueue.length;
                let i = 0;
                while (i < length) {
                    const event = item.sdkQueue.shift();
                    event?.func.call(event.context, ...(event.payload ?? []));
                    i++;
                }
            }
        }
        catch (err) {
            feishuRobotSend({ err: err, text: [`[${type}] consumeByType error`] });
        }
    };
}
const TaskQueue = new _TaskQueue();

/** 可以接入的SDK名称列表 */
var MonitorCoreSDKEnum;
(function (MonitorCoreSDKEnum) {
    MonitorCoreSDKEnum["RUMS"] = "RUMS";
    MonitorCoreSDKEnum["ARMS"] = "ARMS";
})(MonitorCoreSDKEnum || (MonitorCoreSDKEnum = {}));

/**
 * ARMS单例
 * https://help.aliyun.com/zh/arms/browser-monitoring/developer-reference/sdk-reference
 * https://help.aliyun.com/zh/arms/browser-monitoring/developer-reference/api-reference
 * https://www.npmjs.com/package/alife-logger?activeTab=code
 */
class ArmsSDK {
    config;
    instance;
    sdkLoaded = false;
    /** 仅加载SDK */
    loadScript = (config) => {
        return new Promise((resolve, reject) => {
            this.sdkLoaded = true;
            window.__bl = { config };
            const script = document.createElement('script');
            script.setAttribute('crossorigin', '');
            script.src = 'https://retcode.alicdn.com/retcode/bl.js';
            document.body.insertBefore(script, document.body.firstChild);
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                reject(false);
            };
        });
    };
    /** 加载SDK方法，内部有防重处理 */
    async init(config) {
        try {
            if (this.sdkLoaded)
                return;
            // 设置实例
            const setInstance = () => {
                // 避免sdk下载完毕后没有执行完毕。
                return new Promise((res) => {
                    setTimeout(() => {
                        if (window.__bl) {
                            this.instance = window.__bl;
                            // 清理之前上报的数据
                            TaskQueue.consumeByType(MonitorCoreSDKEnum.ARMS);
                        }
                        res(this.instance);
                    }, 100);
                });
            };
            // 组装config
            const rumsConfig = {
                environment: getEnv(),
                imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
                appType: 'web',
                autoSendPerf: true,
                sendResource: true,
                enableLinkTrace: true,
                behavior: true,
                useFmp: true,
                ignore: {
                    ignoreErrors: [/^Script error\.?$/],
                },
                ...config,
            };
            this.config = rumsConfig;
            await this.loadScript(rumsConfig);
            await setInstance();
            return this.instance;
        }
        catch (e) {
            console.log('Arms initialization failed');
            console.error(e);
            return undefined;
        }
    }
    /** 发送异常事件 */
    sendException = (error, pos, properties) => {
        try {
            if (!this.instance) {
                return TaskQueue.push(MonitorCoreSDKEnum.RUMS, this.sendException, [error, pos, properties], this);
            }
            // 处理自定义参数
            this.setProperties(properties);
            this.instance.error(error, pos);
            // 清空自定义参数
            this.setProperties();
        }
        catch (e) {
            console.error(e);
            feishuRobotSend({
                text: ['Arms sendException error', error?.toString?.()],
                err: e,
            });
        }
    };
    /**
     * arms的properties体现在c1/c2/c3参数，
     * 此处设置的property是全局设置，每次事件都会带上，
     * 但是不会覆盖初次init时候的设置的property
     *  */
    setProperties(payload) {
        try {
            if (!this.instance)
                return TaskQueue.push(MonitorCoreSDKEnum.RUMS, this.setProperties, [payload], this);
            let c1 = this.config?.c1 ?? '';
            let c2 = this.config?.c2 ?? '';
            let c3 = this.config?.c3 ?? '';
            let _payload = payload;
            if (payload && typeof payload === 'object') {
                if (Array.isArray(payload)) {
                    _payload = { data: payload };
                    c3 += getJSONstring(_payload);
                }
                else {
                    Object.keys(payload).forEach((key) => {
                        if (!c1) {
                            c1 = `${key}: ${getJSONstring(payload[key])}, `;
                        }
                        else if (!c2) {
                            c2 = `${key}: ${getJSONstring(payload[key])}, `;
                        }
                        else {
                            c3 += `${key}: ${getJSONstring(payload[key])}, `;
                        }
                    });
                }
                c1 = c1?.substring(0, c2 ? (c3 ? 1000 : 3000) : 5000);
                c2 = c2?.substring(0, c3 ? 5000 : 2000);
                c3 = c3?.substring(0, 2000);
            }
            this.setConfig({
                c1,
                c2,
                c3,
            });
        }
        catch (e) {
            console.error(e);
            feishuRobotSend({
                text: 'Arms setProperties error',
                err: e,
            });
        }
    }
    /** 设置用户名 */
    setUser(payload) {
        try {
            if (!this.instance)
                return TaskQueue.push(MonitorCoreSDKEnum.RUMS, this.setUser, [payload], this);
            this.setConfig({
                setUsername: () => payload,
            });
        }
        catch (e) {
            console.error(e);
            feishuRobotSend({
                text: 'Arms setUser error',
                err: e,
            });
        }
    }
    /** 配置设置 */
    setConfig(payload) {
        try {
            if (!this.instance)
                return TaskQueue.push(MonitorCoreSDKEnum.RUMS, this.setConfig, [payload], this);
            const config = this.instance.getConfig();
            const newConfig = {
                ...config,
                ...payload,
            };
            this.instance.setConfig(newConfig);
            this.config = newConfig;
        }
        catch (e) {
            console.error(e);
            feishuRobotSend({
                text: 'Arms setConfig error',
                err: e,
            });
        }
    }
    /** 获取config */
    getConfig() {
        try {
            if (!this.instance)
                return;
            return this.instance.getConfig();
        }
        catch (e) {
            console.error(e);
            feishuRobotSend({
                text: 'Arms getConfig error',
                err: e,
            });
            return undefined;
        }
    }
}

/**
 * RUMS单例
 * https://help.aliyun.com/zh/arms/user-experience-monitoring/web-h5-sdk-configuration-reference
 */
class ArmsRumsSDK {
    config;
    instance;
    sdkLoaded = false;
    /** 仅加载SDK */
    loadScript = (config) => {
        return new Promise((resolve, reject) => {
            this.sdkLoaded = true;
            window.__rum = config;
            const script = document.createElement('script');
            script.setAttribute('crossorigin', '');
            script.src = 'https://sdk.rum.aliyuncs.com/v2/browser-sdk.js ';
            document.body.insertBefore(script, document.body.firstChild);
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                reject(false);
            };
        });
    };
    /** 加载SDK方法，内部有防重处理 */
    async init(config) {
        try {
            if (this.sdkLoaded)
                return;
            // 设置实例
            const setInstance = () => {
                // 避免sdk下载完毕后没有执行完毕。
                return new Promise((res) => {
                    setTimeout(() => {
                        if (window.RumSDK) {
                            this.instance = window.RumSDK.default;
                            // 清理之前上报的数据
                            TaskQueue.consumeByType(MonitorCoreSDKEnum.RUMS);
                        }
                        res(this.instance);
                    }, 100);
                });
            };
            // 组装config
            const rumsConfig = {
                env: getEnv(),
                tracing: true,
                // tracing: {
                //   allowedUrls: [
                //     {
                //       match: (url: string) => /^https?:\/\/*/.test(url) || url.includes('insta360.com'),
                //       propagatorTypes: ['tracecontext'],
                //     },
                //   ],
                // },
                collectors: {
                    /**
                     * 为了便于本地调试，在上报之前会console.error，如果开启自动监听，将重复上报。
                     * rum会使用console.error的异常覆盖自定义上报异常，导致自定义信息丢失。
                     * 所以监控内关闭自动监听
                     */
                    consoleError: false,
                },
                whiteScreen: {
                    detectionRules: [
                        {
                            target: 'body',
                            test_when: ['LOAD', 'ERROR', 'ROUTE_CHANGE', 'LEAVE'],
                            delay: 100,
                            tester: 'SAMPLE',
                        },
                    ],
                },
                ...config,
            };
            this.config = rumsConfig;
            await this.loadScript(rumsConfig);
            await setInstance();
            return this.instance;
        }
        catch (e) {
            console.log('RUMS initialization failed');
            console.error(e);
            return undefined;
        }
    }
    /** 发送异常事件 */
    sendException = (payload) => {
        try {
            if (!this.instance)
                return TaskQueue.push(MonitorCoreSDKEnum.RUMS, this.sendException, [payload], this);
            this.instance.sendException(payload);
        }
        catch (e) {
            console.error(e);
            feishuRobotSend({
                text: ['RUMS sendException error', getJSONstring(payload)],
                err: e,
            });
        }
    };
    /** 发送自定义事件 */
    sendEvent = (payload) => {
        try {
            if (!this.instance)
                return TaskQueue.push(MonitorCoreSDKEnum.RUMS, this.sendEvent, [payload], this);
            this.instance.sendCustom(payload);
        }
        catch (e) {
            console.error(e);
            feishuRobotSend({
                text: 'RUMS sendEvent error',
                err: e,
            });
        }
    };
    /**
     * rums设置的property是全局设置，每次事件都会带上，
     * 但是不会覆盖初次init时候的设置的property
     *  */
    setProperties(payload) {
        try {
            if (!this.instance)
                return TaskQueue.push(MonitorCoreSDKEnum.RUMS, this.setProperties, [payload], this);
            if (!payload)
                return;
            let _payload = payload;
            if (Array.isArray(payload.data)) {
                _payload = { data: payload };
            }
            if (typeof payload !== 'object') {
                _payload = { data: `${payload}` };
            }
            this.setConfig({
                properties: _payload,
            });
        }
        catch (e) {
            console.error(e);
            feishuRobotSend({
                text: 'RUMS setProperties error',
                err: e,
            });
        }
    }
    /**
     * 设置用户信息
     * @param {string | IArmsRumUser} payload name字段或者{name:,tags?:}
     */
    setUser(payload) {
        try {
            if (!this.instance)
                return TaskQueue.push(MonitorCoreSDKEnum.RUMS, this.setUser, [payload], this);
            const currentUser = this.getConfig()?.user || {};
            this.setConfig({
                user: typeof payload === 'string' ? { ...currentUser, name: payload } : { ...currentUser, ...payload },
            });
        }
        catch (e) {
            console.error(e);
            feishuRobotSend({
                text: 'RUMS setUser error',
                err: e,
            });
        }
    }
    /** 配置设置 */
    setConfig = (payload) => {
        try {
            if (!this.instance)
                return TaskQueue.push(MonitorCoreSDKEnum.RUMS, this.setConfig, [payload], this);
            const config = this.instance.getConfig();
            const newConfig = {
                ...config,
                ...payload,
            };
            this.instance.setConfig(newConfig);
            this.config = newConfig;
        }
        catch (e) {
            console.error(e);
            feishuRobotSend({
                text: 'RUMS setConfig error',
                err: e,
            });
        }
    };
    /** 获取config */
    getConfig = () => {
        try {
            if (!this.instance)
                return;
            return this.instance.getConfig();
        }
        catch (e) {
            console.error(e);
            feishuRobotSend({
                text: 'RUMS getConfig error',
                err: e,
            });
            return undefined;
        }
    };
}

class MonitorCore {
    static instance;
    SDKs = {};
    /** 禁止外部实例化MonitorCore，全局只能有一个实例，就是通过getInstance获取 */
    constructor() { }
    /** 实例化挂载监控组件，之后就可以使用window.monitorCore调用 */
    static init() {
        if (!isBrowser)
            return;
        if (!MonitorCore.instance) {
            MonitorCore.instance = new MonitorCore();
            window.monitorCore = MonitorCore.instance;
        }
        return MonitorCore.instance;
    }
    /** 注册单个SDK实例 */
    registerSDK(type, config) {
        if (!isBrowser)
            return Promise.resolve(true);
        return new Promise((resolve) => {
            switch (type) {
                case MonitorCoreSDKEnum.ARMS:
                    if (this.SDKs[MonitorCoreSDKEnum.ARMS])
                        return;
                    const armsInstance = new ArmsSDK();
                    this.SDKs[MonitorCoreSDKEnum.ARMS] = armsInstance;
                    armsInstance.init(config);
                    break;
                case MonitorCoreSDKEnum.RUMS:
                    if (this.SDKs[MonitorCoreSDKEnum.RUMS])
                        return;
                    const rumsInstance = new ArmsRumsSDK();
                    this.SDKs[MonitorCoreSDKEnum.RUMS] = rumsInstance;
                    rumsInstance.init(config);
                    break;
            }
            resolve(true);
        }).catch((e) => {
            console.error(e);
        });
    }
    /**
     * 错误上报
     * @param {Error | string | null} Error 错误
     * @param {string} payload.filename 异常发生文件名 / JS文件URL
     * @param {object} payload.properties 携带的自定义信息
     */
    sendException = (error, payload) => {
        if (!isBrowser || !error)
            return;
        console.error(error);
        let errCol = undefined;
        let errLine = undefined;
        if (error instanceof Error) {
            const { colno, lineno } = getErrorPos(error);
            errCol = colno;
            errLine = lineno;
        }
        // 遍历所有待上报的SDK，存放至queue中，待SDK加载完毕后统一执行
        Object.keys(MonitorCoreSDKEnum).forEach((sdk) => {
            switch (sdk) {
                case MonitorCoreSDKEnum.ARMS:
                    const armsParams = [
                        error,
                        {
                            filename: payload.filename,
                            lineno: errLine,
                            colno: errCol,
                        },
                        payload.properties,
                    ];
                    if (!this.SDKs[MonitorCoreSDKEnum.ARMS]) {
                        TaskQueue.push(MonitorCoreSDKEnum.ARMS, this.sendException, [error, payload], this);
                    }
                    else {
                        this.SDKs[MonitorCoreSDKEnum.ARMS].sendException(...armsParams);
                    }
                    break;
                case MonitorCoreSDKEnum.RUMS:
                    const rumsParams = [
                        {
                            name: typeof error === 'string' ? 'CustomError' : error.name,
                            message: typeof error === 'string' ? error : error.message,
                            file: payload.filename,
                            stack: error.stack ?? undefined,
                            line: errLine,
                            column: errCol,
                            properties: payload.properties,
                        },
                    ];
                    if (!this.SDKs[MonitorCoreSDKEnum.RUMS]) {
                        TaskQueue.push(MonitorCoreSDKEnum.RUMS, this.sendException, [error, payload], this);
                    }
                    else {
                        this.SDKs[MonitorCoreSDKEnum.RUMS].sendException(...rumsParams);
                    }
                    break;
            }
        });
    };
    /**
     * 发送自定义事件，只有RUMS支持
     * @param {string} type 类型
     * @param {string} name 名称
     * @param {string} group 分组
     * @param {number} value 值
     * @param {Record<string, unknown>} properties 自定义属性
  
     */
    sendEvent = (event) => {
        if (!isBrowser)
            return;
        Object.keys(MonitorCoreSDKEnum).forEach((sdk) => {
            switch (sdk) {
                case MonitorCoreSDKEnum.RUMS:
                    if (!this.SDKs[MonitorCoreSDKEnum.ARMS]) {
                        TaskQueue.push(MonitorCoreSDKEnum.RUMS, this.sendEvent, [event], this);
                    }
                    else {
                        this.SDKs[MonitorCoreSDKEnum.RUMS].sendEvent(event);
                    }
                    break;
            }
        });
    };
    /**
     * 设置全局属性，但是不会覆盖首次init时设置的properties
     * @param {Record<string, unknown>g} properties 限制对象，但是内部做了容错处理，可以传入数组、对象、字符串
     */
    setProperties = (properties) => {
        if (!isBrowser)
            return;
        Object.keys(MonitorCoreSDKEnum).forEach((sdk) => {
            switch (sdk) {
                case MonitorCoreSDKEnum.ARMS:
                    if (!this.SDKs[MonitorCoreSDKEnum.ARMS]) {
                        TaskQueue.push(MonitorCoreSDKEnum.ARMS, this.setProperties, [properties], this);
                    }
                    else {
                        this.SDKs[MonitorCoreSDKEnum.ARMS].setProperties(properties);
                    }
                    break;
                case MonitorCoreSDKEnum.RUMS:
                    if (!this.SDKs[MonitorCoreSDKEnum.RUMS]) {
                        TaskQueue.push(MonitorCoreSDKEnum.RUMS, this.setProperties, [properties], this);
                    }
                    else {
                        this.SDKs[MonitorCoreSDKEnum.RUMS].setProperties(properties);
                    }
                    break;
            }
        });
    };
    /**
     * 设置用户信息
     * @param {string} user string，可以是id或者email，但是需要注意是否涉及用户隐私
     * @param {}
     */
    setUser = (user) => {
        if (!isBrowser || !user)
            return;
        Object.keys(MonitorCoreSDKEnum).forEach((sdk) => {
            switch (sdk) {
                case MonitorCoreSDKEnum.ARMS:
                    if (!this.SDKs[MonitorCoreSDKEnum.ARMS]) {
                        TaskQueue.push(MonitorCoreSDKEnum.ARMS, this.setUser, [user], this);
                    }
                    else {
                        this.SDKs[MonitorCoreSDKEnum.ARMS].setUser(typeof user === 'string' ? user : user.name);
                    }
                    break;
                case MonitorCoreSDKEnum.RUMS:
                    if (!this.SDKs[MonitorCoreSDKEnum.RUMS]) {
                        TaskQueue.push(MonitorCoreSDKEnum.RUMS, this.setUser, [user], this);
                    }
                    else {
                        this.SDKs[MonitorCoreSDKEnum.RUMS].setUser(user);
                    }
                    break;
            }
        });
    };
    /**
     * 设置config
     */
    setConfig = (sdk, config) => {
        if (!isBrowser)
            return;
        switch (sdk) {
            case MonitorCoreSDKEnum.ARMS:
                if (!this.SDKs[MonitorCoreSDKEnum.ARMS]) {
                    TaskQueue.push(MonitorCoreSDKEnum.ARMS, this.setConfig, [sdk, config], this);
                }
                else {
                    this.SDKs[MonitorCoreSDKEnum.ARMS].setConfig(config);
                }
                break;
            case MonitorCoreSDKEnum.RUMS:
                if (!this.SDKs[MonitorCoreSDKEnum.RUMS]) {
                    TaskQueue.push(MonitorCoreSDKEnum.RUMS, this.setConfig, [sdk, config], this);
                }
                else {
                    this.SDKs[MonitorCoreSDKEnum.RUMS].setConfig(config);
                }
                break;
        }
    };
    /**
     * 获取配置
     * @returns {any} 配置对象
     */
    getConfig = (sdk) => {
        if (!isBrowser)
            return undefined;
        switch (sdk) {
            case MonitorCoreSDKEnum.ARMS:
                return this.SDKs[MonitorCoreSDKEnum.ARMS]?.getConfig();
            case MonitorCoreSDKEnum.RUMS:
                return this.SDKs[MonitorCoreSDKEnum.RUMS]?.getConfig();
        }
        return undefined;
    };
    /**
     * 获取事件queue
     */
    getEventQueue = () => {
        if (!isBrowser)
            return [];
        return TaskQueue.queue;
    };
}

export { MonitorCore as default };
